import api from "/api";
import events from "/events";
import notify from "/utils/notify";
import globals from "/utils/globals";
import { consent } from "/services/cookiebot";

const state = {
  segment: null,
  loggedIn: null,
  canTrial: null,
  plans: {
    items: [],
    yearlySavedPercents: null
  },
  supportedLanguages: globals.configSupportedLanguages,
  cookies: {
    submitted: null,
    consented: null,
    options: {
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false
    }
  }
};

const getters = {
  isUserPremium: state => {
    return state.segment === "premium";
  },
  isUserBasic: state => {
    return state.segment === "basic";
  },
  isUserLoggedOut: state => {
    return state.loggedIn === false;
  },
  isUserLoggedIn: state => {
    return state.loggedIn === true;
  },
  canTrial: state => {
    return state.canTrial === true;
  },
  trialDays: (state, getters) => {
    if (getters.canTrial && state.plans.items.length > 0) {
      const yearlyPlan = state.plans.items.find(a => a.type === "yearly");
      if (yearlyPlan) {
        return yearlyPlan.trialDays;
      }
    }
    return 0;
  },
  noBasicPlans: state => {
    return state.plans ? state.plans.items.filter(a => a.type !== "basic") : [];
  },
  planByType: state => type => {
    return state.plans.items.find(a => a.type === type);
  },
  currencyDisclaimer: (state) => {
    for (let plan of state.plans.items) {
      if (plan.disclaimer) {
        return plan.disclaimer;
      }
    }
  },
  yearlySavedPercents: state => {
    return state.plans.yearlySavedPercents;
  },
  supportedLanguages: state => {
    return state.supportedLanguages;
  },
  displayConsentBanner: state => {
    return state.cookies.submitted === false;
  }
};

const mutations = {
  segment: (state, payload) => {
    state.segment = payload;
  },
  loggedIn: (state, payload) => {
    state.loggedIn = payload;
  },
  canTrial: (state, payload) => {
    state.canTrial = payload;
  },
  plans: (state, payload) => {
    state.plans.items = [...payload];
  },
  yearlySavedPercents: (state, payload) => {
    state.plans.yearlySavedPercents = payload;
  },
  supportedLanguages: (state, payload) => {
    state.supportedLanguages = payload;
  },
  cookiesSubmitted: (state, payload) => {
    state.cookies = {
      ...state.cookies,
      submitted: payload
    };
  },
  cookiesConsented: (state, payload) => {
    state.cookies = {
      ...state.cookies,
      consented: payload
    };
  },
  cookiesOptions: (state, payload) => {
    state.cookies.options = {
      ...state.cookies.options,
      ...payload
    };
  }
};

const actions = {
  setup: ({ commit }, payload) => {
    commit("segment", payload.segment);
    commit("loggedIn", !payload.guest);
    commit("supportedLanguages", payload.supported_languages);
  },
  plans: ({ commit }) => {
    api.plans()
      .then(data => {
        commit("canTrial", data.canTrial);
        commit("plans", data.plans);
        commit("yearlySavedPercents", data.yearlySavedPercents);
        events.emit("plans:ready", data);
      })
      .catch(error => {
        notify("Failed to fetch plans");
        events.emit("plans:error", error);
      });
  },
  initCookies: ({ commit }, payload) => {
    commit("cookiesSubmitted", true);
    commit("cookiesConsented", payload.consented);
    commit("cookiesOptions", payload.options);
    events.emit("cookies:ready");
  },
  consentAllCookies: ({ dispatch }) => {
    dispatch("consentCookies", {
      preferences: true,
      statistics: true,
      marketing: true
    });
  },
  consentCookies: (_, payload) => {
    // Necessary cookies must always be on
    consent({ ...payload, necessary: true });
    events.track("store-20200728-user", "1-consent-cookies", payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
